const obj = {
  id: '',
  name: '',
  email: '',
  hasFace: false,
}

export default function FaceRecognitionAwsReportModel(params = obj) {
  return { ...obj, ...params, };
};
